var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoFeatured(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6981 14.9552C18.7388 16.6867 18.0596 18.3694 16.7938 19.6729C15.528 20.9763 13.7672 21.8064 11.857 22H11.8455C16.2066 19.4828 15.1656 14.8638 12.1727 11.7966C12.5382 14.8621 12.8157 18.0724 9.30231 19.169C9.1454 18.0793 9.6238 17.2983 10.1328 16.4983C7.26242 18.2414 7.63174 20.6069 9.22577 21.8603C7.56708 21.5038 6.08617 20.6623 5.01434 19.4673C3.94251 18.2724 3.34012 16.7912 3.30127 15.2552C3.21516 11.6034 6.96389 10.5672 5.4732 6.21552C6.2042 6.32586 7.80205 7.07759 8.80286 8.21207C7.44612 5.88966 7.02704 2.57586 12.2952 0C9.71756 4.8931 18.5737 9.73793 18.6981 14.9552Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFeatured);
export default __webpack_public_path__ + "static/media/ico-featured.79737fb20c29836a9096701a6927fe0f.svg";
export { ForwardRef as ReactComponent };